import { useEffect, useRef } from "react";

// Canvas waveform from server-computed peaks; played part is lit, click to seek.
export const Waveform = ({ peaks = [], progress = 0, onSeek, height = 56, color = "#C8FF4D", testId }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const dpr = window.devicePixelRatio || 1;
    const w = c.clientWidth;
    c.width = w * dpr; c.height = height * dpr;
    const g = c.getContext("2d");
    g.scale(dpr, dpr);
    g.clearRect(0, 0, w, height);
    const n = peaks.length || 1;
    const bw = w / n;
    peaks.forEach((p, i) => {
      const h = Math.max(2, p * (height - 6));
      g.fillStyle = i / n <= progress ? color : "rgba(255,255,255,0.18)";
      g.fillRect(i * bw + bw * 0.15, (height - h) / 2, Math.max(1, bw * 0.7), h);
    });
  }, [peaks, progress, height, color]);
  return (
    <canvas ref={ref} data-testid={testId} style={{ height }} className={`w-full ${onSeek ? "cursor-pointer" : ""}`}
      onClick={(e) => { if (!onSeek) return; const r = e.currentTarget.getBoundingClientRect(); onSeek((e.clientX - r.left) / r.width); }} />
  );
};
